let development = true;

if (process.env.NODE_ENV == undefined || process.env.NODE_ENV == "" || process.env.NODE_ENV == "production") {
  development = false;
}

let port = 5300;

module.exports.development = development;
module.exports.port = port;